import React from 'react';
import { useTranslation } from 'react-i18next';
import NoPendingInvitations from '../../../../../assets/images/ill_empty_access_sharing_invite_received.svg';
import PendingReceivedInvitationRow from './PendingReceivedInvitationRow';
import { Invitation } from 'services/api/invitations/types';

interface IPendingReceivedInvitations {
  isMobile: boolean;
  invitations: Invitation[];
}

function PendingReceivedInvitations(props: IPendingReceivedInvitations) {
  const { t } = useTranslation();

  return (
    <div className="access-sharing-subcontainer">
      <div className="access-sharing-subcontainer-header">
        <h3>{t('pending_received_invitations_title')}</h3>
      </div>
      <div className="access-sharing-subcontainer-body">
        {props.invitations.length === 0 ? (
          <div className="access-sharing-subcontainer-body-empty">
            <div className="access-sharing-body-picture">
              <img src={NoPendingInvitations}></img>
            </div>
            <div className="access-sharing-body-text">
              <h4>{t('pending_no_received_invitations_title')}</h4>
              <p>{t('pending_no_received_invitations_text')}</p>
            </div>
          </div>
        ) : (
          <div className="access-sharing-subcontainer-body-table">
            <div className="access-sharing-subcontainer-body-table-header pending-received-invitation">
              <div>{t('equipment_or_fleet')}</div>
              <div>{t('role')}</div>
              <div>{t('invited_by')}</div>
              <div>{t('start_time')}</div>
              <div>{t('end_time')}</div>
              <div></div>
            </div>
            <div className="access-sharing-subcontainer-body-table-body pending-received-invitation">
              {props.invitations.map(invitation => {
                return (
                  <PendingReceivedInvitationRow
                    key={invitation.exposedAccessSharingRecordId}
                    isMobile={props.isMobile}
                    invitation={invitation}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PendingReceivedInvitations;
